import PictureTypes from '../enums/pictureTypes';

const pictureTypeDescription = {
  [PictureTypes.Damage]: 'Foto de los daños del vehículo',
  [PictureTypes.LicensePicture]: 'Foto de la licencia del conductor',
  [PictureTypes.VehicleRegistryPicture]: 'Foto de la matrícula del vehículo',
  [PictureTypes.VehicleLeftSidePicture]: 'Foto del lado izquierdo del vehículo',
  [PictureTypes.VehicleRightSidePicture]: 'Foto del lado derecho del vehículo',
  [PictureTypes.VehicleFrontPicture]: 'Foto del lado frontal del vehículo',
  [PictureTypes.VehicleBackPicture]: 'Foto del lado trasero del vehículo',
  [PictureTypes.VehicleVinPicture]: 'Foto del número de chasis del vehículo',
  [PictureTypes.VehicleGlassPicture]: 'Foto del cristal roto',
  [PictureTypes.VehiclePlatePicture]: 'Foto de la placa del vehículo',
  [PictureTypes.VehicleMileagePicture]: 'Foto del kilometraje del vehículo',
  [PictureTypes.VehicleMarbetePicture]: 'Foto del marbete del vehículo',
  [PictureTypes.PoliceRegistryPicture]:
    'Foto del registro policial del accidente',
  [PictureTypes.DriverIdPicture]:
    'Foto del documento de identifiación del conductor',
};

export default pictureTypeDescription;
